<p-dialog [(visible)]="exibeCadastro" [style]="{width: '900px'}" [header]="cadastroTitulo" [modal]="true"
  styleClass="p-fluid" (onHide)="hideDialog()">
  <ng-template pTemplate="content">

    <div class="p-fluid p-formgrid p-grid">
      <ng-container *ngIf="isForm">
        <div *ngIf="state == 1" class="p-field p-col-6">
          <p-checkbox [(ngModel)]="cadastro.todosDealer" [binary]="true" label="Todos os Dealers"
            [disabled]="state === 0"></p-checkbox>
        </div>
      </ng-container>
      <div *ngIf="state === 1" class="p-field p-col-6">
        <p-checkbox [binary]="true" label="Preenchimento via Arquivo" [disabled]="state === 0"
          (onChange)="alteraFormulario()"></p-checkbox>
      </div>

      <ng-container *ngIf="isForm">
        <div *ngIf="!cadastro.todosDealer" class="p-field p-col-12">
          <label>Dealers:</label>
          <p-dropdown [showClear]="true" [options]="dealerOptions" [(ngModel)]="cadastro.id" [filter]="true"
            placeholder="{{'Dealer'}}" appendTo="body" optionLabel="nome_dealer" optionValue="id_dealer"
            [disabled]="state === 0">
          </p-dropdown>
          <small class="p-invalid text-danger" *ngIf="submitted && !cadastro.id">Dealer é
            Obrigatório!</small>
        </div>
      </ng-container>

      <div *ngIf="isForm" class="p-field p-col-12">
        <label>Tipo Previsão:</label>
        <p-dropdown [showClear]="true" field="tipo" id="tipo" [options]="categoriaVendaOptions"
          [(ngModel)]="cadastro.id_categoria_venda" placeholder="{{'Tipo Previsão'}}" optionLabel="nome_categoria_venda"
          optionValue="id_categoria_venda" [filter]="true" appendTo="body" required [disabled]="state === 0"
          (onChange)="onTipoPrevisaoChange()">
        </p-dropdown>
        <small class="p-invalid text-danger" *ngIf="submitted && !cadastro.id_categoria_venda">Tipo Previsão é
          Obrigatório!</small>
      </div>

      <div *ngIf="isForm && isPrevisaoVendaVeiculos()" class="p-field p-col-12">
        <label>Família:</label>
        <p-dropdown [showClear]="true" [options]="familiaOptions"
          [(ngModel)]="cadastro.id_veiculos" placeholder="{{'Família'}}" optionLabel="nome_familia"
          optionValue="id_familia" [filter]="true" appendTo="body" required [disabled]="state === 0">
        </p-dropdown>
        <small class="p-invalid text-danger" *ngIf="submitted && !cadastro.id_veiculos && isPrevisaoVendaVeiculos()">Família é
          Obrigatória para Previsão Venda Veículos!</small>
      </div>

      <div *ngIf="isForm" class="p-field p-col-6">
        <label>Ano:</label>
        <p-dropdown [showClear]="true" id="tipo" [options]="listaAnos" [(ngModel)]="cadastro.ano"
          placeholder="{{'Ano'}}" [filter]="true" [virtualScroll]="true" appendTo="body" required
          optionLabel="descricao" optionValue="ano" [disabled]="state === 0">
        </p-dropdown>
        <small class="p-invalid text-danger" *ngIf="submitted && !cadastro.ano">Ano é
          Obrigatório!</small>
      </div>

      <div *ngIf="isForm" class="p-field p-col-6">
        <label>Mês:</label>
        <p-calendar [(ngModel)]="cadastro.mesDate" view="month" dateFormat="MM" placeholder="{{'Mês'}}" appendTo="body"
          [disabled]="state === 0">
        </p-calendar>
        <small class="p-invalid text-danger" *ngIf="submitted && !cadastro.mesDate">Mês é
          Obrigatório!</small>
      </div>

      <div *ngIf="isForm" class="p-field p-col-12">
        <label *ngIf="cadastro.tipo_valor">Valor:</label>

        <p-inputNumber *ngIf="cadastro.tipo_valor === 'S'" [(ngModel)]="cadastro.valor" mode="currency" currency="BRL"
          locale="pt-BR" [disabled]="state === 0">
        </p-inputNumber>

        <p-inputNumber *ngIf="cadastro.tipo_valor === 'N'" [(ngModel)]="cadastro.valor" [disabled]="state === 0">
        </p-inputNumber>

        <small class="p-invalid text-danger" *ngIf="submitted && !cadastro.valor">Valor é
          Obrigatório!</small>
      </div>

      <div *ngIf="isForm" class="p-field p-col-12">
        <label class="mr-2">Tipo Valor:</label>
        <p-radioButton #monetario (onClick)="cadastro.tipo_valor = monetario.value" value="S" label="Monetário"
          [(ngModel)]="cadastro.tipo_valor" [disabled]="state === 0" class="mr-2">
        </p-radioButton>
        <p-radioButton #qtd (onClick)="cadastro.tipo_valor = qtd.value" value="N" label="Quantidade"
          [(ngModel)]="cadastro.tipo_valor" [disabled]="state === 0">
        </p-radioButton>
      </div>
    </div>

    <ng-container *ngIf="!isForm">
      <div class="jumbotron">
        <div class="row">
          <div class="col-10">
            <legend translate>{{'parametros.previsaoVenda.cadastro.dadosPrincipais.legenda1'}}</legend>
            <legend translate>{{'parametros.previsaoVenda.cadastro.dadosPrincipais.legenda2'}}</legend>
            <legend translate>{{'parametros.previsaoVenda.cadastro.dadosPrincipais.legenda3'}}</legend>
            <legend translate>{{'parametros.previsaoVenda.cadastro.dadosPrincipais.legenda4'}}</legend>
            <legend translate>{{'parametros.previsaoVenda.cadastro.dadosPrincipais.legenda5'}}</legend>
          </div>
          <div class="col-2">
            <div class="float-right mr-4">
              <a class="btn download" href="assets/modelos/modelo-previsao-venda.xlsx">
                <i class="fas fa-file-download"></i>
              </a>
              {{'parametros.previsaoVenda.cadastro.dadosPrincipais.modelo' | translate}}
            </div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="state == 1">
        <div class="col col-lg-12">
          <p translate class="text-info">
            {{'parametros.previsaoVenda.cadastro.dadosPrincipais.adicionarArquivoXlsCadastro'}}</p>
          <p-fileUpload mode="advanced" fileLimit="1" name="myfile[]" customUpload="true" accept=".xlsx"
            (uploadHandler)="uploader($event)">
          </p-fileUpload>
        </div>
      </div>
    </ng-container>
  </ng-template>
  <ng-template pTemplate="footer">
    <button *ngIf="state !== 0 && isForm" pButton label="Salvar" icon="pi pi-check" class="p-button-text" (click)="saveDados()">
    </button>
    <button *ngIf="isForm" pButton label="Cancelar" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
  </ng-template>
</p-dialog>
